export default "__VITE_ASSET___o6ImYSi__"